import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then(m => m.LoginPage),
  },
  {
    path: 'signup',
    loadComponent: () => import('./pages/auth/signup/signup.component').then(m => m.SignupPage),
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/property-tracker/dashboard/dashboard.component').then(m => m.DashboardPage),
    canActivate: [authGuard],
  },
  {
    path: 'legal-entities-management',
    loadComponent: () => import('./pages/legal-entities-management/legal-entities-management.component').then(m => m.LegalEntitiesManagementComponent),
    canActivate: [authGuard],
  },
  {
    path: 'officials-management',
    loadComponent: () => import('./pages/officials-management/officials-management.component').then(m => m.OfficialsManagementComponent),
    canActivate: [authGuard],
  },
  {
    path: 'add-edit-official-form',
    loadComponent: () => import('./pages/add-edit-official-form/add-edit-official-form.component').then(m => m.AddEditOfficialFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'add-edit-official-form/:id',
    loadComponent: () => import('./pages/add-edit-official-form/add-edit-official-form.component').then(m => m.AddEditOfficialFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'add-edit-legal-entity-form',
    loadComponent: () => import('./pages/add-edit-legal-entity-form/add-edit-legal-entity-form.component').then(m => m.AddEditLegalEntityFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'add-edit-legal-entity-form/:id',
    loadComponent: () => import('./pages/add-edit-legal-entity-form/add-edit-legal-entity-form.component').then(m => m.AddEditLegalEntityFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'legal-entity-details/:id',
    loadComponent: () => import('./pages/legal-entity-details/legal-entity-details.component').then(m => m.LegalEntityDetailsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'financial-reports-registry',
    loadComponent: () => import('./pages/financial-reports-registry/financial-reports-registry.component').then(m => m.FinancialReportsRegistryComponent),
    canActivate: [authGuard],
  },
  {
    path: 'legal-entities/:legalEntityId/financial-reports/add',
    loadComponent: () => import('./pages/financial-report-form/financial-report-form.component').then(m => m.FinancialReportFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'legal-entities/:legalEntityId/financial-reports/:year/:period',
    loadComponent: () => import('./pages/financial-report-form/financial-report-form.component').then(m => m.FinancialReportFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'legal-entities/:legalEntityId/financial-reports/:year/:period/edit',
    loadComponent: () => import('./pages/financial-report-form/financial-report-form.component').then(m => m.FinancialReportFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'official-details/:id',
    loadComponent: () => import('./pages/official-details/official-details.component').then(m => m.OfficialDetailsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'properties-management',
    loadComponent: () => import('./pages/properties-management/properties-management.component').then(m => m.PropertiesManagementComponent),
    canActivate: [authGuard],
  },
  {
    path: 'land-plots-management',
    loadComponent: () => import('./pages/land-plots-management/land-plots-management.component').then(m => m.LandPlotsManagementComponent),
    canActivate: [authGuard],
  },
  {
    path: 'add-edit-land-plot-form',
    loadComponent: () => import('./pages/add-edit-land-plot-form/add-edit-land-plot-form.component').then(m => m.AddEditLandPlotFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'add-edit-land-plot-form/:id',
    loadComponent: () => import('./pages/add-edit-land-plot-form/add-edit-land-plot-form.component').then(m => m.AddEditLandPlotFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'land-plot-details/:id',
    loadComponent: () => import('./pages/land-plot-details/land-plot-details.component').then(m => m.LandPlotDetailsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'transport-management',
    loadComponent: () => import('./pages/transport-management/transport-management.component').then(m => m.TransportManagementComponent),
    canActivate: [authGuard],
  },
  {
    path: 'add-edit-transport-form',
    loadComponent: () => import('./pages/add-edit-transport-form/add-edit-transport-form.component').then(m => m.AddEditTransportFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'add-edit-transport-form/:id',
    loadComponent: () => import('./pages/add-edit-transport-form/add-edit-transport-form.component').then(m => m.AddEditTransportFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'transport-details/:id',
    loadComponent: () => import('./pages/transport-details/transport-details.component').then(m => m.TransportDetailsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'add-edit-property-form',
    loadComponent: () => import('./pages/add-edit-property-form/add-edit-property-form.component').then(m => m.AddEditPropertyFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'add-edit-property-form/:id',
    loadComponent: () => import('./pages/add-edit-property-form/add-edit-property-form.component').then(m => m.AddEditPropertyFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'property-details/:id',
    loadComponent: () => import('./pages/property-details/property-details.component').then(m => m.PropertyDetailsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'activity-log',
    loadComponent: () => import('./pages/activity-log/activity-log.component').then(m => m.ActivityLogComponent),
    canActivate: [authGuard],
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [authGuard],
  },
  {
    path: 'notifications',
    loadComponent: () => import('./pages/notifications/notifications.component').then(m => m.NotificationsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'inspections',
    loadComponent: () => import('./pages/inspections-overview/inspections-overview.component').then(m => m.InspectionsOverviewComponent),
    canActivate: [authGuard],
  },
  {
    path: 'terminations',
    loadComponent: () => import('./pages/terminations-overview/terminations-overview.component').then(m => m.TerminationsOverviewComponent),
    canActivate: [authGuard],
  },
  {
    path: 'charity',
    loadComponent: () => import('./pages/charity-overview/charity-overview.component').then(m => m.CharityOverviewComponent),
    canActivate: [authGuard],
  },
  {
    path: 'rent',
    loadComponent: () => import('./pages/rent-overview/rent-overview.component').then(m => m.RentOverviewComponent),
    canActivate: [authGuard],
  },
  {
    path: 'tasks',
    loadComponent: () => import('./pages/tasks/tasks.component').then(m => m.TasksComponent),
    canActivate: [authGuard],
  },
  {
    path: 'analytics',
    loadComponent: () => import('./pages/analytics/analytics.component').then(m => m.AnalyticsComponent),
    canActivate: [authGuard],
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundPage),
  },
];
